import Header from "./components/Header";
import Hero from "./components/Hero";
import TodayList from "./components/TodayList";
import HotRank from "./components/HotRank";
import Collections from "./components/Collections";
import Zones from "./components/Zones";
import Scenes from "./components/Scenes";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-[#faf6ef] font-sans text-stone-800 antialiased">
      <Header />
      <main>
        <Hero />
        <TodayList />
        <HotRank />
        <Collections />
        <Zones />
        <Scenes />
      </main>
      <Footer />
    </div>
  );
}